import { createModelPermissions } from 'components/permissions/utils/model-permission-generator';

const OrganizerConst = createModelPermissions({
  modelName: 'organizers',
  basePath: '/organizers',
  permissions: {
    VIEW: true,
    UPDATE: true,
    DELETE: true,
    CHANGE_STATUS: true,
  }
});

export default OrganizerConst;
